module.exports = __webpack_public_path__ + "static/img/btn.57cf6621.webp";